import { render, staticRenderFns } from "./FieldAttachment.vue?vue&type=template&id=5cc9b6b1&"
import script from "./FieldAttachment.vue?vue&type=script&lang=js&"
export * from "./FieldAttachment.vue?vue&type=script&lang=js&"
import style0 from "./FieldAttachment.vue?vue&type=style&index=0&id=5cc9b6b1&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QCircularProgress,QImg,QTooltip,QSpinnerIos,QSeparator,QCardActions,QBtn});
